import { render, staticRenderFns } from "./RecruitView.vue?vue&type=template&id=0525af4a&"
import script from "./RecruitView.vue?vue&type=script&lang=ts&"
export * from "./RecruitView.vue?vue&type=script&lang=ts&"
import style0 from "./RecruitView.vue?vue&type=style&index=0&id=0525af4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports